import { UTCDate } from '@date-fns/utc'

export const FORGD_SYSTEM_COINGECKO_ID = 'forgd'
export const FORGD_SYSTEM_PROJECT_ID = '00000000-a270-4d52-8cb0-6e6605dce512'
export const FORGD_SYSTEM_PROJECT_TICKER = 'FRGD'

export const MAX_MARKET_MAKERS_PER_PROJECT = 8

export const DEFAULT_TGE_DATE = new UTCDate('2023-12-31').toISOString()
export const DEFAULT_COINGECKO_ID = 'solana'
export const DEFAULT_TICKER = 'SOL'

export const DEFAULT_BI_COINGECKO_ID = 'metaplex' // default coingecko id for research projects
export const DEFAULT_BI_TICKER = 'MPLX'

// default maximum token supply and fully diluted valuation
export const DEFAULT_MTS = 1e9
export const DEFAULT_FDV = 5e7

// multiplier used when calculating estimated monthly fee
// for DMM quotes with single exchange coverage
export const SINGLE_EXCHANGE_FEE_MULTIPLIER = 4

export const SETTINGS_PARAMETER_WEEKLY_REPORTS = 'WEEKLY_REPORTS'
export const SETTINGS_PARAMETER_CONSULTATION_CALENDAR_CONNECTION = 'consultation_calendar_connection'
export const SETTINGS_PARAMETER_CONSULTATION_BOOKING_POLICY = 'consultation_booking_policy'

// first-party cookie holding the affiliate click id captured from `?fgclick=<uuid>`
export const FGCLICK_COOKIE_NAME = 'fgclick'

// first-party cookie holding the analytics consent choice;
// bump the version when the cookie policy materially changes to re-prompt visitors
export const CONSENT_COOKIE_NAME = 'forgd-cookie-consent'
export const CONSENT_COOKIE_VERSION = 1

export const DEFAULT_MARKET_CAP_RANK = 1000 // only match from top 1000 coins by market cap

// Telegram's maximum message length is 4096 characters
// Reference: https://core.telegram.org/bots/api#sendmessage
export const TELEGRAM_MAX_MESSAGE_LENGTH = 4096

// Slack's maximum message length is 40000 characters
// Reference: https://api.slack.com/reference/surfaces/formatting#message-limits
export const SLACK_MAX_MESSAGE_LENGTH = 40000
